export default __webpack_public_path__ + "static/media/soesvinget-property-07.9ce87809.jpg";